var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRectangleRoundTag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "a",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 6.8h22.9a2.9 2.9 0 0 1 2.9 2.9V55a2.9 2.9 0 0 1-2.9 2.9H36.7a2.9 2.9 0 0 1-2.9-2.9V9.7a2.9 2.9 0 0 1 2.9-2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59 55.9H37.3a1.37 1.37 0 0 1-1.4-1.4V10.2a1.37 1.37 0 0 1 1.4-1.4H59a1.37 1.37 0 0 1 1.4 1.4v44.3a1.43 1.43 0 0 1-1.4 1.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1 12.1a3.3 3.3 0 1 0 3.3 3.3 3.33 3.33 0 0 0-3.3-3.3Zm0 5.1a1.8 1.8 0 1 1 1.8-1.8 1.79 1.79 0 0 1-1.8 1.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m67.3 60.9 1.5-2.1a1 1 0 0 1 1.3-.2l14.3 10.1a1 1 0 0 1 .2 1.3l-1.5 2.1a1 1 0 0 1-1.3.2L67.6 62.2a.89.89 0 0 1-.3-1.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4 73.4a2 2 0 0 1-1.1-.3L67 63a1.93 1.93 0 0 1-.5-2.7l1.5-2.1a1.93 1.93 0 0 1 2.7-.5L85 67.8a2 2 0 0 1 .5 2.6L84 72.5a1.92 1.92 0 0 1-1.6.9Zm-12.8-14-1.5 2.1 14.3 10.1 1.5-2Zm14.3 10.1.8.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m71.287 64.418 2.599-3.674 1.551 1.097-2.598 3.674z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1,
    cy: 54.2,
    r: 11.6,
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66.7a12.55 12.55 0 1 1 7.3-22.8 12.52 12.52 0 0 1 3 17.5A12.35 12.35 0 0 1 60 66.7Zm0-23.2A10.6 10.6 0 1 0 70.7 54a10.19 10.19 0 0 0-4.6-8.6 10.75 10.75 0 0 0-6.1-1.9Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 61.4h-3.7l-1.7-4H54a8 8 0 0 0 8-8v-6.7l4 .8v5.8a11.85 11.85 0 0 1-11.9 12.1Z"
  })));
};
export default SvgRectangleRoundTag;